<div class="sign-out-container">
  <div class="content" (click)="signOut()">
    <img class="image" src="../../../../assets/icons/sign-out.svg">
  </div>
</div>
